<div class="add-card">
  <div class="add-head">
    <mat-icon>add_circle_outline</mat-icon>
    <!-- « Reprise de matériel » = reprise hors contrat (JP 29/10) : matériel qu'aucune ligne ne suit, repris sans toucher aux locations du dossier. -->
    <mat-button-toggle-group class="add-mode" [value]="mode" (change)="setMode($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Livraison ou reprise">
      <mat-button-toggle value="deliver" class="mode-deliver"><span class="mode-label">Livrer un matériel<mat-icon>arrow_forward</mat-icon></span></mat-button-toggle>
      <mat-button-toggle value="return" class="mode-return" matTooltip="Reprendre un matériel qu'aucun dossier ne suit : jamais facturé, il ne clôt aucune location"><span class="mode-label"><mat-icon>arrow_back</mat-icon>Reprise de matériel</span></mat-button-toggle>
    </mat-button-toggle-group>
    <!-- Recherche dans l'en-tête de la carte (JP 28/10) : la carte fermée sur l'article ne fait qu'une rangée. -->
    <app-search-product #searchProduct class="add-search" width="510px" [is_ht]="isHt" aria-label="Article" (blurEmitter)="onSearchBlur($event)" (selectProductEmitter)="onSelectProduct($event)"></app-search-product>
    @if (mode === 'deliver' && form.product) {
      <div class="chosen"><mat-icon>inventory_2</mat-icon>{{ form.product.name }}</div>
    }
    @if (mode === 'return' && ret.product) {
      <div class="chosen"><mat-icon>inventory_2</mat-icon>{{ ret.product.name }}</div>
    }
    <span class="spacer"></span>
    <button mat-stroked-button class="hdr-btn" (click)="closed.emit()"><mat-icon>close</mat-icon>Fermer</button>
  </div>

  @if (mode === 'return') {
    @if (ret.product) {
      <div class="add-row fields">
        <div class="field">
          <label class="field-label" for="ret-memo">Patient</label>
          <input id="ret-memo" class="text-input patient-input" [(ngModel)]="ret.memo" placeholder="Chambre · nom, imprimé sur le BL" autocomplete="off" [matAutocomplete]="retPatientAuto" />
          <mat-autocomplete #retPatientAuto="matAutocomplete" panelWidth="560px">
            @for (p of patientOptions; track p.key) {
              <mat-option [value]="p.memo"><span class="pp-memo">{{ p.memo }}</span><span class="pp-products">{{ plural(p.products.length, 'matériel', 'matériels') }} · {{ p.products.join(' · ') }}</span></mat-option>
            }
          </mat-autocomplete>
        </div>
        <div class="field">
          <label class="field-label" for="ret-qty">Quantité</label>
          <input id="ret-qty" class="text-input num-input short" type="number" [value]="1" disabled matTooltip="Un matériel par reprise : plusieurs matériels font plusieurs reprises" />
        </div>
        <div class="field">
          <label class="field-label" for="ret-detail">Précision, imprimée sur le BL</label>
          <input id="ret-detail" class="text-input patient-input" [(ngModel)]="ret.detail" placeholder="N° de série, état, ancien dossier…" autocomplete="off" />
        </div>
        <div class="field actions">
          <button mat-flat-button class="hdr-btn accent" (click)="submitReturn()" [disabled]="saving || !!returnProblem" [matTooltip]="returnProblem ?? ''"><mat-icon>save</mat-icon>Programmer la reprise</button>
        </div>
      </div>
    }
    <div class="add-hint">@if (returnProblem; as pb) { {{ pb }} · }Reprise rattachée à aucune location : jamais facturée, elle ne clôt aucun matériel du dossier. Elle part sur le BL du client.</div>
  }

  @if (mode === 'deliver' && form.product && !form.terms) {
    <div class="terms-list">
      <!-- TEMPORAIRE (vitrine-rental-pick) : visibleTerms remplace form.product.lnk_rental_terms ?? []. -->
      @for (rt of visibleTerms; track rt.id) {
        <button type="button" class="terms-card" [class.has-error]="termsError(rt)" (click)="selectTerms(rt)">
          <span class="terms-name">{{ rt.name }}</span>
          <span class="terms-detail">{{ periodName(rt.period) }}@if (termsPrice(rt); as tp) { · {{ tp }} } @else { · prix à saisir }</span>
          @if (rt.tiered_pricing.length && rt.tiered_pricing[0].fse_lpp) {
            <span class="terms-detail">LPP {{ rt.tiered_pricing[0].fse_lpp }}@if (rt.tiered_pricing[0].tarifref != null) { ({{ m(rt.tiered_pricing[0].tarifref) }} €) }</span>
          }
          @if (termsError(rt)) {
            <span class="terms-error"><mat-icon>error_outline</mat-icon>{{ rt.error || 'Tarif de référence LPP introuvable ou expiré' }}</span>
          }
        </button>
      } @empty {
        <div class="add-hint">Aucun contrat de cet article n'est proposé pour ce payeur facturé.</div>
      }
    </div>
  }

  @if (mode === 'deliver' && form.terms) {
    <div class="add-row">
      <div class="chosen terms"><mat-icon>description</mat-icon>{{ form.terms.name }}
        <button type="button" class="link-btn" (click)="changeTerms()">changer</button>
      </div>
      <!-- Produits liés du contrat (forfait…) : ajoutés en lignes de vente avec le matériel, sur le même BL. -->
      @if (form.linked; as lk) {
        <div class="linked">
          <span class="linked-label">Ajouté à la livraison :</span>
          @if (lk.loading) { <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary" aria-label="Lecture des produits liés"></mat-progress-spinner> }
          @for (it of lk.items; track it.productId) {
            <span class="linked-item" [class.has-error]="!!it.problem" [matTooltip]="it.problem ?? ''">{{ it.name }} × {{ it.quantity }}@if (!it.problem) { · {{ linkedPrice(it) }} }@if (it.notSold) { · non vendable }</span>
          }
        </div>
      }
    </div>
    <div class="add-row fields">
      <div class="field">
        <label class="field-label" for="add-memo">Patient</label>
        <input id="add-memo" class="text-input patient-input" [(ngModel)]="form.memo" placeholder="Chambre · nom, imprimé sur le BL" autocomplete="off" [matAutocomplete]="patientAuto" />
        <!-- Patients déjà présents : en choisir un recopie son mémo à l'identique (même rangée au Planning, même texte sur le BL). -->
        <mat-autocomplete #patientAuto="matAutocomplete" panelWidth="560px">
          @for (p of patientOptions; track p.key) {
            <mat-option [value]="p.memo"><span class="pp-memo">{{ p.memo }}</span><span class="pp-products">{{ plural(p.products.length, 'matériel', 'matériels') }} · {{ p.products.join(' · ') }}</span></mat-option>
          }
        </mat-autocomplete>
      </div>
      <div class="field">
        <label class="field-label" for="add-price">Prix {{ taxLabel }} par {{ periodName(form.terms.period) }}</label>
        <input id="add-price" class="text-input num-input" type="number" min="0" step="0.01" [(ngModel)]="form.price" (ngModelChange)="form.priceTouched = true" />
      </div>
      <div class="field">
        <label class="field-label" for="add-duration" matTooltip="Durée maximale en périodes ; vide = sans limite">Durée</label>
        <div class="inline">
          <input id="add-duration" class="text-input num-input short" type="number" min="1" step="1" [(ngModel)]="form.duration" [disabled]="form.unlimited" />
          <span class="unit">{{ periodName(form.terms.period) }}(s)</span>
          <mat-checkbox color="primary" [(ngModel)]="form.unlimited">Sans limite</mat-checkbox>
        </div>
      </div>
      <div class="field actions">
        <button mat-flat-button class="hdr-btn accent" (click)="submit()" [disabled]="saving || !!problem" [matTooltip]="problem ?? ''"><mat-icon>save</mat-icon>Enregistrer</button>
      </div>
    </div>
    @if (problem; as pb) { <div class="add-hint">{{ pb }}</div> }
    @if (patientMatch; as pm) {
      <div class="add-hint same-patient"><mat-icon>link</mat-icon>
        @if (pm.exact) { Rattaché à « {{ pm.patient.memo }} », qui a déjà {{ plural(pm.patient.products.length, 'matériel', 'matériels') }} : même rangée au Planning. }
        @else { Même rangée au Planning que « {{ pm.patient.memo }} », mais écrit autrement sur le BL : choisissez-le dans la liste pour l'écrire à l'identique. }
      </div>
    }
  }
</div>
